import React from 'react';
import { Link } from 'react-router-dom';
import { prestationsOrganisme } from '../data/mockData';
import FormationCard from '../components/FormationCard';

const Prestations = () => {
  return (
    <div>
      {/* Hero Section */}
      <div 
        className="relative h-[400px] flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1640145867966-be8e200a7891?w=1920&h=400&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>
        
        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="mb-4 text-sm">
            <Link to="/" className="text-gray-300 hover:text-white">Accueil</Link>
            <span className="mx-2 text-red-500">/</span>
            <span className="text-red-500">Prestations en organisme</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 uppercase tracking-wide">
            Prestations en organisme
          </h1>
          
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
            Nous intervenons directement dans votre établissement avec du matériel professionnel
          </p>
        </div>
      </div>

      {/* Info Section */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Formations sur mesure dans vos locaux
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Nous nous déplaçons dans votre structure avec tout le matériel nécessaire pour dispenser 
              des formations de qualité. Tarifs dégressifs selon le nombre de participants.
            </p>
          </div>
        </div>
      </section>

      {/* Formations Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {prestationsOrganisme.map((category) => (
              <FormationCard key={category.id} category={category} type="prestations" />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Prestations;